import React from 'react';
import '../css/Section.css';

function BackupSection() {
  return (
    <section id="backup" className="section image-split-section">
      <div className="section-container reverse">
        <div className="section-image storm-image large" aria-label="Home powered during a storm" />

        <div className="section-text">
          <p className="eyebrow">Reliable Backup Protection</p>
          <h2>Storms are inevitable. Blackouts aren't.</h2>
          <p>
            Keep your home running smoothly through any power failure. 
            The Aevolt Everflow proactively charges to maximum capacity ahead of severe weather. 
          </p>
          <p>
            When the grid fails, it switches to stored energy instantly, 
            ensuring your lights and essential appliances never skip a beat.
          </p>
        </div>
      </div>
    </section>
  );
}

export default BackupSection;
